import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dollar' })
export class DollarPipe implements PipeTransform {

    transform(value: any) {
        if (value) {
            return '$'.concat(value);
        }
        return value;
    }

}
